import { createContext, useContext, useEffect, useState } from "react"

export const StepContext = createContext({})

export const StepProvider = ({ children, steps, start, stepper }) => {
  if (!steps) {
    console.error(
      new Error(
        `Couldn't find steps. Check documentation to create your steps.`,
      ),
    )

    return null
  }

  if (!steps[start]) {
    console.error(
      new Error(
        `Couldn't find start matching. "start" should be a key from your "steps": ${Object.keys(
          steps,
        ).join(" or ")}`,
      ),
    )

    return null
  }

  const [current, setCurrent] = useState()
  const [stepProps, setStepProps] = useState({})

  useEffect(() => {
    setCurrent({
      ...steps[start],
      name: start,
    })
  }, [steps])

  const setConfig = (config) => {
    if (config?.state) {
      setStepProps(config?.state)
    } else {
      setStepProps({})
    }
  }

  const next = (stepName, config) => {
    setCurrent({
      ...steps[stepName],
      name: stepName,
    })

    setConfig(config)
  }

  const prev = (stepName, config) => {
    setCurrent({
      ...steps[stepName],
      name: stepName,
    })

    setConfig(config)
  }

  const values = {
    current,
    next,
    prev,
    start,
    steps,
    state: stepProps,
  }

  return <StepContext.Provider value={values}>{children}</StepContext.Provider>
}

export const useStep = () => {
  const context = useContext(StepContext)
  if (!context) {
    throw new Error(
      `useStep hook must be used within a 'StepProvider' component`,
    )
  }

  return context
}

export const Step = (props) => {
  const context = useStep()
  const Component = context?.current?.component
  if (Component) {
    return <Component {...context} {...props} />
  }

  return null
}
